<app-spinner></app-spinner>
<mat-toolbar class="header mat-elevation-z8">
  <div class="header-content">
    <a href="">
      <img class="logoWapi" src="assets/img/logo-WAPI-Blanco.png" [alt]="labels.logoWapi" />
    </a>
    <a href="">
      <img class="logoAlc" src="assets/img/LOGOESCUDOSDS-optimized.png" [alt]="labels.logoAlc" />
    </a>
  </div>
</mat-toolbar>

<div class="container center-h center-v">
  <mat-card-content>
    <h1>
      <strong>{{ labels.signIn }}</strong>
    </h1>
    <form
      [formGroup]="loginForm"
      (ngSubmit)="onLogin()"
      novalidate
      fxLayout="column wrap"
      fxLayoutAlign="center center"
      fxLayoutGap="10px"
    >
      <mat-form-field>
        <mat-label>{{ labels.username }}</mat-label>
        <input type="text" matInput formControlName="email" />
        @if (hasFieldError('email', 'required')) {
          <mat-error>{{ labels.usernameRequired }}</mat-error>
        }
        @if (hasFieldError('email', 'email')) {
          <mat-error>{{ labels.emailInvalid }}</mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ labels.password }}</mat-label>
        <input type="password" matInput formControlName="Pwp" />
        @if (hasFieldError('Pwp', 'required')) {
          <mat-error>{{ labels.passwordRequired }}</mat-error>
        }
        @if (hasFieldError('Pwp', 'minLength')) {
          <mat-error>{{ labels.passwordMinLength }}</mat-error>
        }
      </mat-form-field>

      <button
        class="button btn"
        type="submit"
        mat-raised-button
        [disabled]="isLoading || !loginForm.valid"
      >
        {{ isLoading ? labels.signingIn : labels.signIn }}
      </button>

      <button (click)="onB2CLogin()" class="button btn" type="button">
        {{ labels.signInB2C }}
      </button>
    </form>
  </mat-card-content>
</div>

<app-footer></app-footer>
